<template>
  <div class="legend-color-dss2 bg-white-opacity-80 p-2 rounded shadow-sm table-small">
    <table class="table table-borderless legend_font_color px-3 m-0 table-bg-white-opacity-0">
      <tbody>
      <!-- Basin area -->
      <tr>
        <td class="pe-1">
          <span
              class="legend-line legend-line-lg bg-color-layer-basin-area align-middle"></span>
        </td>
        <td class="text-muted">{{ $t('Works.Basin') }}</td>
        <td class="fw-bold text-muted text-end">&nbsp;</td>
      </tr>

      <!-- Rivers -->
      <tr v-if="propRiversShow === true">
        <td class="pe-1">
            <span
                class="legend-line bg-color-anthropic-work-derivation bg-color-anthropic-work-river align-middle"></span>
        </td>
        <td class="text-muted">{{ $t('Works.River') }}</td>
        <td class="fw-bold text-muted text-end">&nbsp;</td>
      </tr>

      <!-- Lakes -->
      <tr v-if="propLakesShow === true">
        <td class="pe-1">
          <span
              class="legend-line legend-line-lg bg-color-lake align-middle"></span>
        </td>
        <td class="text-muted">{{ $t('Works.Lakes') }}</td>
        <td class="fw-bold text-muted text-end">{{ propLakesNatural }}</td>
      </tr>

      <!-- Glaciers -->
      <tr v-if="propGlacierShow === true">
        <td class="pe-1">
          <span
              class="legend-line legend-line-lg bg-color-glacier align-middle"></span>
        </td>
        <td class="text-muted">{{ $t('Works.Glaciers') }}</td>
        <td class="fw-bold text-muted text-end">{{ propGlaciers }}</td>
      </tr>

      <!-- Administrative units -->
      <tr v-if="propAdministrativeUnitsShow === true">
        <td class="pe-1">
            <span
                class="legend-line bg-color-layer-municipalities align-middle"></span>
        </td>
        <td class="text-muted">{{ $t('Works.Municipality') }}</td>
        <td class="fw-bold text-muted text-end">&nbsp;</td>
      </tr>

      <!-- Agriculture areas -->
      <tr v-if="propAgricultureAreaShow === true">
        <td class="pe-1">
          <span
              class="legend-line legend-line-lg bg-color-agriculture-area align-middle"></span>
        </td>
        <td class="text-muted">{{ $t('Works.AgricultureAreas') }}</td>
        <td class="fw-bold text-muted text-end">&nbsp</td>
      </tr>

      <!-- Water infrastructure -->
      <template v-if="propAnthropicWorksShow === true">
        <tr>
          <td class="legend_font_size fw-semibold pt-2" colspan="3">
            {{ $t('SimulationInputs.AnthropicWorks') }}
          </td>
        </tr>
        <!-- Legend Entry: Derivations -->
        <tr>
          <td class="pe-1">
            <span class="legend-color rounded-circle bg-color-anthropic-work-derivation align-middle"></span>
          </td>
          <td class="text-muted">{{ $t('Works.DerivationPoint') }}</td>
          <td class="fw-bold text-muted text-end">{{ propDerivationPoints }}</td>
        </tr>

        <!-- Legend Entry: Eaves -->
        <tr>
          <td class="pe-1">
            <span class="legend-line legend-line-lg bg-color-anthropic-work-derivation align-middle"></span>
          </td>
          <td class="text-muted">{{ $t('Works.Derivation') }}</td>
          <td class="fw-bold text-muted text-end">{{ propDerivations }}</td>
        </tr>

        <tr>
          <td class="pe-1">
          <span class="align-middle text-color-anthropic-work-derivation-direction">
            <i class="bi bi-arrow-down-up"></i>
          </span>
          </td>
          <td class="text-muted">{{ $t('Works.DerivationAddress') }}</td>
          <td class="fw-bold text-muted text-end">&nbsp;</td>
        </tr>

        <!-- Dams -->
        <tr>
          <td class="pe-1">
            <span class="legend-color rounded-circle bg-color-anthropic-work-lake align-middle"></span>
          </td>
          <td class="text-muted">{{ $t('Works.DamLake') }}</td>
          <td class="fw-bold text-muted text-end">{{ propLakes }}</td>
        </tr>

        <!-- Hydroelectrical stations -->
        <tr>
          <td class="pe-1">
            <span class="legend-color rounded-circle bg-color-anthropic-work-plant align-middle"></span>
          </td>
          <td class="text-muted">{{ $t('Works.Plant') }}</td>
          <td class="fw-bold text-muted text-end">{{ propStations }}</td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    propLakesShow: {
      type: Boolean,
      default: false
    },
    propGlacierShow: {
      type: Boolean,
      default: false
    },
    propAgricultureAreaShow: {
      type: Boolean,
      default: false
    },
    propRiversShow: {
      type: Boolean,
      default: true,
    },
    propLakesNatural: {
      type: Number,
      default: 0, // Default value if no data is received
    },
    propGlaciers: {
      type: Number,
      default: 0, // Default value if no data is received
    },
    propAdministrativeUnitsShow: {
      type: Boolean,
      default: true,
    },
    propAnthropicWorksShow: {
      type: Boolean,
      default: true,
    },
    propLakes: {
      type: Number,
      default: 0, // Default value if no data is received
    },
    propDerivations: {
      type: Number,
      default: 0,
    },
    propDerivationPoints: {
      type: Number,
      default: 0,
    },
    propStations: {
      type: Number,
      default: 0,
    },
  },
};
</script>

